// extracted by mini-css-extract-plugin
export default {"container":"Inviter_container__aYYEL","text":"Inviter_text__K6oUF"};